module.exports = __webpack_public_path__ + "img/ic_launching_tip.8631b8ec.png";